/**
 * @generated SignedSource<<5ad11b43c7864afc29c9e2884c59cbfc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ScrapSourceDeleteInput = {
  id: string;
};
export type ScrapSourceId_scrapSourceDeleteMutation$variables = {
  input: ScrapSourceDeleteInput;
};
export type ScrapSourceId_scrapSourceDeleteMutation$data = {
  readonly scrapSourceDelete: {
    readonly id: string;
  };
};
export type ScrapSourceId_scrapSourceDeleteMutation = {
  response: ScrapSourceId_scrapSourceDeleteMutation$data;
  variables: ScrapSourceId_scrapSourceDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ScrapSourceId_scrapSourceDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ScrapSource",
        "kind": "LinkedField",
        "name": "scrapSourceDelete",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ScrapSourceId_scrapSourceDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ScrapSource",
        "kind": "LinkedField",
        "name": "scrapSourceDelete",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteRecord",
            "key": "",
            "kind": "ScalarHandle",
            "name": "id"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ced39cd21aa0a822ff08834abfd6f0a2",
    "id": null,
    "metadata": {},
    "name": "ScrapSourceId_scrapSourceDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation ScrapSourceId_scrapSourceDeleteMutation(\n  $input: ScrapSourceDeleteInput!\n) {\n  scrapSourceDelete(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "0f9a357af1795e149861cc9aaa7ef6b4";

export default node;
